import { io } from 'socket.io-client';

const socketUrl = import.meta.env.VITE_SOCKET_URL || import.meta.env.VITE_API_URL || 'http://localhost:3000';

const socket = io(socketUrl, {
  transports: ['polling', 'websocket'], // Polling primeiro como fallback
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 20000,
  withCredentials: true,
  upgrade: true, // Tenta fazer upgrade para websocket após conectar com polling
  rememberUpgrade: true,
});

socket.on('connect', () => {
  console.log('✅ Socket conectado:', socket.id);
  console.log('Transport usado:', socket.io.engine.transport.name);
});

socket.on('connect_error', (error) => {
  console.error('❌ Erro de conexão socket:', error.message);
  console.log('Tentando reconectar...');
});

socket.on('disconnect', (reason) => {
  console.log('Socket desconectado:', reason);
});

socket.on('reconnect', (attemptNumber) => {
  console.log('Socket reconectado após', attemptNumber, 'tentativas');
});

/**
 * Pedido cuja room este socket acompanha. O backend só emite o
 * `payment-confirmed` para a room do pedido (`order:<orderId>`, #555) — antes
 * ia para todo visitante do checkout.
 */
let pedidoAcompanhado: string | null = null;

// Room não sobrevive à reconexão (o servidor vê um socket novo): a cada
// `connect` entra de novo na room do pedido acompanhado. Quem registra
// listener de `connect` tem que tirar só o próprio (`socket.off('connect',
// handler)`) — `socket.off('connect')` sem handler apagaria este também.
socket.on('connect', () => {
  if (pedidoAcompanhado) socket.emit('join-order', pedidoAcompanhado);
});

/**
 * Entra na room do pedido para receber o `payment-confirmed` dele. Um pedido
 * por vez: chamar com outro sai do anterior (o servidor faz isso). Sem conexão,
 * só guarda — o `connect` acima entra quando conectar.
 */
export function acompanharPedido(orderId: string | number | null | undefined): void {
  if (orderId == null || orderId === '') return;
  pedidoAcompanhado = String(orderId);
  if (socket.connected) socket.emit('join-order', pedidoAcompanhado);
}

export default socket;
